/**
* This code was copied from `/include/table-engine/js/plugins/filterForm.js` file
* and was slightly refactored
*/

import $ from 'jquery';
import Handlebars from 'handlebars';

import './style.scss';

function initFeaturedFilters({
  $calculator,
  $table,
  source,
  noResults,
  tableOrder = 0,
}) {
  const template = Handlebars.compile(source);
  const noResultsTemplate = Handlebars.compile(noResults);
  const $filtersWrapper = $calculator.find('.filters');
  const {
    category: categoryId,
    site,
    fieldset,
  } = $calculator[0].dataset;

  $filtersWrapper.append(template({ tableOrder }));

  const $filters = $filtersWrapper.find('form');

  const FILTER_OPEN = 'filter-open';
  const IS_SHOWN = 'is-shown';
  const IS_HIDDEN = 'is-hidden';

  const $tbody = $table.find('tbody');
  const itemsTotal = $tbody.find('tr').length;

  const show = ($element) => {
    $element.addClass(IS_SHOWN).removeClass(IS_HIDDEN);
    $('body').addClass(FILTER_OPEN);
    $element.attr('aria-hidden', false);
  };

  const hide = ($element) => {
    $element.removeClass(IS_SHOWN).addClass(IS_HIDDEN);
    $('body').removeClass(FILTER_OPEN);
    $element.attr('aria-hidden', false);

    setTimeout(() => $element.removeClass(IS_HIDDEN));
  };

  const toggleShow = ($element) => {
    if ($element.hasClass(IS_SHOWN)) {
      hide($element);
    } else {
      show($element);
    }
  };

  /**
   * Transforms input fields in array format into json format (property name and value)
   *
   * @param inputArray - list of fields with value
   * @returns {{}} - e.g {bonusPoints: ">=1", annualFee: ">=0,<=199"}
   */
  const transformInputToJson = (inputArray) => {
    const fields = inputArray.reduce((prevAcc, field) => {
      const acc = Object.assign({}, prevAcc);

      if (!acc[field.name]) {
        acc[field.name] = field.value;
      } else {
        acc[field.name] += ` || ${field.value}`;
      }

      return acc;
    }, {});

    return fields;
  };

  function filterTable(url) {
    const onTableBodyFetched = ({ html }) =>
      new Promise((resolve, reject) => {
        if (!html) {
          reject({
            count: 0,
            html: noResultsTemplate(),
          });
        } else {
          const itemsCount = (html.match(/<tr/g) || []).length;
          resolve({
            count: itemsCount,
            html,
          });
        }
      });

    const displayResults = (results) => {
      const {
        count: curreentItemsTotal,
      } = results;

      setButtons({ length: curreentItemsTotal });
      setNumbers(curreentItemsTotal, itemsTotal);

      return results;
    };

    const displayNoResults = (results) => {
      setButtons({ length: 0 });
      setNumbers(0, itemsTotal);

      return results;
    };

    $table.trigger('onLoading');

    $.get(url)
      .then(onTableBodyFetched)
      .then(displayResults, displayNoResults)
      .always(results => $table.trigger('onLoaded', results));
  }

  function decodeFields(fields) {
    if (!fields) {
      return '';
    }

    const comparatorMap = {
      '<=': 'lte',
      '<': 'lt',
      '===': 'eq',
      '!==': 'neq',
      '>=': 'gte',
      '>': 'gt',
      '|==': 'in',
    };

    const extractURI = ({
      fieldName,
      idx,
      rawValue,
    }) => {
      const [, comparator, value] = rawValue.match(/^([><=!]+)(.+)$/);
      const shouldSetInComparator = value.indexOf('/') !== -1;

      let uriComparator = comparatorMap[comparator];
      let uriValue = value;

      const shoulOmitFilter = uriValue === 'all';

      if (shoulOmitFilter) {
        return null;
      }

      if (shouldSetInComparator) {
        uriComparator = 'in';
        uriValue = value.replace('/', ',');
      }

      return [
        `filters[${idx}][field]=${fieldName}`,
        `filters[${idx}][comparator]=${uriComparator}`,
        `filters[${idx}][value]=${uriValue}`,
      ].join('&');
    };

    const decodedFields = Object.keys(fields)
      .reduce((acc, name) => {
        const bindWithFieldName = value => [name, value];
        const rawValues = fields[name]
          .split(',')

          .map(bindWithFieldName);
        return [...acc, ...rawValues];
      }, [])
      .map(([name, value], idx) =>
        extractURI({
          rawValue: value,
          fieldName: name,
          idx,
        }),
      );

    return decodedFields
      .filter(field => field !== null)
      .join('&');
  }

  /**
   * Resets filter form to its initial state
   * Fields added here are checkbox and radio (may add as needed)
   *
   * @params $form
   * @params fields - applied fields before changes are done
   * @params defaultValue - checkbox/radio input values
   */
  function resetForm($form, fields, defaultValue = true) {
    /* eslint new-cap:0 */
    const deferred = $.Deferred();

    if (fields.length) {
      fields.map((item) => {
        const $obj = $form.find(`[name='${item.name}'][value='${item.value}']`);
        if ($obj.attr('type') === 'checkbox' || $obj.attr('type') === 'radio') {
          $obj.attr('checked', defaultValue);
        }

        return item;
      });
    }

    // Return selected fields in json format
    deferred.resolve(transformInputToJson(fields));

    return deferred;
  }

  // Tag ID to Filter Form button anchor
  $filters.closest('.js-table-engine').find('.js-filter-results')
    .attr('href', `#${$filters.attr('id')}`);

  // Storage of fields/filters selected
  let fieldsSelected = [];

  // Temporary storage of fields/filters selected
  let fieldsSelectedTemp = [];

  $filters.on('filter-form:change', (e, id, fields) => {
    const url = [
      `${window.location.origin}/wordpress/wp-admin/admin-ajax.php?action=redraw_table_ajax`,
      'template=comparison',
      `site=${site}`,
      `category=${categoryId}`,
      `fieldset=${fieldset}`,
      decodeFields(fields),
    ].join('&');

    filterTable(url);
  });

  // Event: Form submit
  $filters.on('submit', (e) => {
    e.preventDefault();

    fieldsSelectedTemp = $filters.serializeArray();
    $filters.trigger('filter-form:change', [
      $filters.attr('id'),
      transformInputToJson(fieldsSelectedTemp),
      fieldsSelectedTemp,
    ]);
  });

  // Event: Input submit
  $filters.on('change', 'input', ({ target }) => {
    const $target = $(target);
    const filterGroupName = $target
      .parents('fieldset')
      .find('legend')
      .text();
    const filterName = $target
      .siblings('label')
      .text();

    $.trackEvent('Table engine', 'Filter', filterGroupName, filterName);

    // Update URL search query on input change
    $filters.submit();
  });

  // Event: Cancel button
  $filters.on('click', '.js-table-engine-filter__cancel', function cancelCallback() {
    resetForm($filters, fieldsSelected, true).done((fields) => {
      hide($($(this).data('target')));

      // delay the custom event to allow for animation to complete
      setTimeout(() => {
        $filters.trigger('filter-form:change', [$filters.attr('id'), fields, fieldsSelected]);
      }, 500);
    });
  });

  // Event: Reset button
  $calculator.on(
    'click',
    '.js-table-engine-filter__reset, .js-table-engine-filter__reset-btn',
    resetFilters,
  );

  // Event: Apply button
  $filters.on('click', '.js-table-engine-filter__apply-btn', (e) => {
    e.preventDefault();
    const $btn = $(e.currentTarget);

    if ($btn.hasClass('btn-disabled')) {
      e.stopPropagation();

      return;
    }

    fieldsSelected = fieldsSelectedTemp;
    toggleShow($filters);
  });

  /**
   * Displays 'No result' message and 'Reset Filter' button when no result was found,
   * Otherwise, display 'Apply Filter' button
   */
  function setButtons(result) {
    const $applyBtn = $filters.find('.js-table-engine-filter__apply-btn');
    const $noResult = $filters.find('.js-table-engine-no-result');

    if (result.length === 0) {
      $applyBtn.addClass('btn-disabled');
      $noResult.removeClass('hide');
    } else {
      $applyBtn.removeClass('btn-disabled');
      $noResult.addClass('hide');
    }
  }

  function setNumbers(count, total) {
    const message = `<span class="weight-semi-bold">${count} of ${total}</span> cards`;

    // Filter Form Mobile / Modal
    $filters.find('.js-table-engine-results-total-modal').html(message);

    // Filter Form Desktop
    $filters.find('.js-table-engine-results-total').html(`Showing ${message}`);
  }

  function resetFilters() {
    $filters[0].reset();
    $filters.trigger('filter-form:change', []);
  }

  $filtersWrapper.on('click', '.js-filter-results', () => toggleShow($filters));

  /**
   * Event to manually reset all fields to default when page is accessed directly,
   * Event triggered when reset button is from another form (No results table result)
   */
  $filters.on('filter-form:reset', resetFilters);

  /**
   * Event to manually update all fields with URL search query
   */
  $filters.on('filter-form:exec-query', (e, filterFormId, fields, queryObj) => {
    // ID indicated in the URL
    const $targetForm = $(`#${filterFormId}`);

    // Filter only the table that is indicated in the URL
    if ($filters.attr('id') === $targetForm.attr('id')) {
      Object.keys(queryObj).forEach((field) => {
        queryObj[field].forEach((value) => {
          const $inputObj = $filters.find(`input[name='${field}'][value='${value}']`);
          if ($inputObj.attr('type') === 'checkbox' || $inputObj.attr('type') === 'radio') {
            $inputObj.prop('checked', true);
          }
        });
      });

      // Store fields selected on page refresh
      fieldsSelected = $filters.serializeArray();

      $filters.submit();
    }
  });

  setButtons({ length: itemsTotal });
  setNumbers(itemsTotal, itemsTotal);
}

export default initFeaturedFilters;
